<template>
  <div class="booking-divider booking-divider-right">
    <div class="booking-content">
      <div class="d-flex flex-column justify-content-center align-items-center h-100 mt-5 px-4 text-default font-size-h3">
        <display-completed v-if="completed"/>
        <payment-required v-else-if="paymentStatus && bookingStatus" :booking-status="bookingStatus" :payment-status="paymentStatus"/>
      </div>
    </div>
    <div class="fixed-buttons">
      <button @click="handleAnotherAppointment" class="btn btn-secondary w-100">
        Book Another Appointment
      </button>
    </div>
  </div>
</template>

<script>
import { WebApi } from '@/services/WebApi'
import { mapState } from 'vuex'
import { SelectedSiteIdMixin } from '@/mixins/Booking/SelectedSiteIdMixin'
import PaymentRequired from '../PaymentRequired.vue'
import DisplayCompleted from '../DisplayCompleted.vue'

export default {
  name: 'Confirmation',
  mixins: [SelectedSiteIdMixin],
  props: {
    token: String
  },
  data () {
    return {
      booking: null
    }
  },
  computed: {
    ...mapState('BookingPayment', [
      'bookingPayment'
    ]),
    paymentStatus () {
      return this.bookingPayment?.status || null
    },
    completed () {
      return this.paymentStatus?.id === 5
    },
    bookingStatus () {
      return this.booking?.status || null
    }
  },
  methods: {
    handleAnotherAppointment () {
      this.$router.push({
        name: 'booking',
        query: { siteId: this.selectedSiteId }
      }).then(() => { window.location.reload() })
    },
    refreshBooking  () {
      const self = this
      self.error = ''
      WebApi.post('ClientBooking/Authenticated', { token: self.token })
        .then(response => { self.booking = response.data })
        .catch(error => { self.error = error })
    }
  },
  created () {
    this.refreshBooking()
  },
  components: {
    'payment-required': PaymentRequired,
    'display-completed': DisplayCompleted
  }
}
</script>
